import { store } from 'redux/store';
import { isAuthenticated } from 'utils/auth';
import { apiInterceptor } from 'utils/apiInterceptor';
export async function ExportPoll(pollId,projectId) {
    const user = store?.getState()?.user
    if (isAuthenticated() && user) {
        const response = await apiInterceptor(
            `${process.env.REACT_APP_MYXP_API_V2}/manager/livestream/polls/${pollId}/export?projectId=${projectId}`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );

        return await response.blob();
    }
}
